import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { CancelIcon } from "../../../../shared/icons/CancelIcon";
import { ChartIcon } from "../../../../shared/icons/ChartIcon";
import { CheckIcon } from "../../../../shared/icons/CheckIcon";
import { checkEmptyValue } from "../../helpers";
import { selectInputValues, selectSelectedModel } from "../../redux/selectors";
import styles from "./styles.module.css";


export const Placeholder = () => {
  const selectedModel = useAppSelector(selectSelectedModel);
  const inputValues = useAppSelector(selectInputValues);
  const { t } = useTranslation();
  return (
    <div className={styles.placeholder}>
      <div>
        <div className={styles["text-container"]}>
          {selectedModel ? (
            <CheckIcon className={styles.icon}/>
          ) : (
            <CancelIcon className={styles.icon}/>
          )}
          <p className={styles.text}>{t("embeddings.instructions_first")}</p>
        </div>
        <div className={styles["text-container"]}>
          {!checkEmptyValue(inputValues) ? (
            <CheckIcon className={styles.icon}/>
          ) : (
            <CancelIcon className={styles.icon}/>
          )}
          <p className={styles.text}>{t("embeddings.instructions_second")}</p>
        </div>
      </div>
      <ChartIcon className={styles.chart}/>
      <div>
        <h3 className={styles["links-title"]}>
          {t("embeddings.educational_material")}
        </h3>
        <div className={styles.links}>
          <a
            target="_blank"
            href="https://habr.com/ru/articles/812431/"
            rel="noreferrer"
          >
            {t("embeddings.about")}
          </a>
        </div>
      </div>
    </div>
  );
};
